module.exports = __webpack_public_path__ + "static/img/slot.b363d42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bad/slot.png
// module id = X42g
// module chunks = 0